import { Field } from "react-final-form";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import moment from "moment-timezone";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import InputAdornment from "@mui/material/InputAdornment";

interface DatePickerProps {
  name: string;
  label?: string;
  helperText?: string;
  required?: boolean;
  format?: string;
  openTo?: "year" | "month" | "day";
  views?: ("year" | "month" | "day")[];
  outputFormat?: "moment" | "date-string" | "iso" | string;
  minDate?: Date | string;
  maxDate?: Date | string;
  [key: string]: any;
}

export function DatePicker(props: DatePickerProps) {
  const {
    format = "DD MMMM YYYY",
    openTo = "day",
    views,
    outputFormat = "iso",
    minDate,
    maxDate,
    ...fieldProps
  } = props;
  return (
    <Field
      {...fieldProps}
      render={({
        input: { onChange, value },
        label,
        helperText,
        required,
      }: any) => (
        <MobileDatePicker
          label={label}
          value={value ? moment(value) : null}
          format={format}
          openTo={openTo}
          views={views}
          minDate={minDate ? moment(minDate) : undefined}
          maxDate={maxDate ? moment(maxDate) : undefined}
          onChange={(value: any) => {
            let outputValue = null;
            if (value) {
              switch (outputFormat) {
                case "date-string":
                  outputValue = moment(value).format("YYYY-MM-DD");
                  break;
                case "iso":
                  outputValue = moment(value).toISOString();
                  break;
                case "moment":
                  outputValue = value;
                  break;
                default:
                  // Кастомный формат
                  outputValue = moment(value).format(outputFormat);
              }
            }

            onChange(outputValue);
          }}
          slots={{
            openPickerButton: (props: any) => {
              return (
                <InputAdornment position="end">
                  {value && (
                    <IconButton
                      size="small"
                      onClick={() => onChange(null)}
                      aria-label="clear"
                      style={{ marginRight: "-4px" }}
                    >
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  )}
                  <IconButton
                    {...props}
                    size="small"
                    color="primary"
                    aria-label="open picker"
                  >
                    {props.children}
                  </IconButton>
                </InputAdornment>
              );
            },
          }}
          slotProps={{
            textField: {
              fullWidth: true,
              required,
              helperText,
            },
          }}
        />
      )}
    />
  );
}
